var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightsAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / flights_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.54385638%",
    y1: "38.1443788%",
    x2: "100%",
    y2: "77.5463191%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "33.6790651%",
    x2: "100%",
    y2: "78.1585595%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.7656642%",
    y1: "50%",
    x2: "55.0540136%",
    y2: "50%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-flights_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flight-info",
    transform: "translate(10.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Line_left---Fill",
    fill: "url(#linearGradient-1)",
    opacity: 0.2554641,
    x: 0,
    y: 57,
    width: 2,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Line_right---Fill",
    fill: "url(#linearGradient-2)",
    opacity: 0.2554641,
    x: 68,
    y: 57,
    width: 2,
    height: 28
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Wing_right---Fill",
    fill: "url(#linearGradient-3)",
    points: "40.5 26 70 44.5 70 52 40.5 42.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Wing_left---Fill",
    fill: "url(#linearGradient-4)",
    transform: "translate(14.750000, 39.000000) scale(-1, 1) translate(-14.750000, -39.000000) ",
    points: "1.42108547e-14 26 29.5 44.5 29.5 52 1.42108547e-14 42.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Wing_right---Border",
    stroke: "#FFFFFF",
    points: "40.5 26 70 44.5 70 52 40.5 42.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Wing_left---Border",
    stroke: "#FFFFFF",
    transform: "translate(14.750000, 39.000000) scale(-1, 1) translate(-14.750000, -39.000000) ",
    points: "0 26 29.5 44.5 29.5 52 0 42.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,5.85487214e-12 C37.9950502,5.85487214e-12 40.5,7.5 40.5,10 C40.5,11.6666667 40.5,29.3333333 40.5,63 L48,70 L48,73.5 L35,70 L22,73.5 L22,70 L29.5,63 C29.5,29.3333333 29.5,11.6666667 29.5,10 C29.5,7.5 32.0049498,5.85487214e-12 35,5.85487214e-12 Z",
    id: "Plane---Fill",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,5.85487214e-12 C37.9950502,5.85487214e-12 40.5,7.5 40.5,10 C40.5,11.6666667 40.5,29.3333333 40.5,63 L48,70 L48,73.5 L35,70 L22,73.5 L22,70 L29.5,63 C29.5,29.3333333 29.5,11.6666667 29.5,10 C29.5,7.5 32.0049498,5.85487214e-12 35,5.85487214e-12 Z",
    id: "Plane---Border",
    stroke: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightsAppTile);
export default __webpack_public_path__ + "static/media/flights_app_tile.f91480ad45ad9b3fa91b481b139c3343.svg";
export { ForwardRef as ReactComponent };